import { useState } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
} from '@mui/material';
import { formatMoney } from '../reports/formatters';
import type { ExpenseCategoryReportRow } from './types';

export const ExpenseCategoryReportDetailsDialog = ({
  row,
  onClose,
}: {
  row: ExpenseCategoryReportRow | null;
  onClose: () => void;
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  if (!row) return null;
  const transactions = row.transactions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return (
    <Dialog open maxWidth="lg" fullWidth onClose={onClose}>
      <DialogTitle>{row.category} — transaction details</DialogTitle>
      <DialogContent dividers>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Date</TableCell>
                <TableCell>Counterparty / Description</TableCell>
                <TableCell align="right">Original Amount</TableCell>
                <TableCell>Currency</TableCell>
                <TableCell align="right">Amount EUR</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transactions.map((transaction) => (
                <TableRow key={transaction.id}>
                  <TableCell>{transaction.date.slice(0, 10)}</TableCell>
                  <TableCell>{transaction.counterpartyDescription}</TableCell>
                  <TableCell align="right">{formatMoney(transaction.originalAmount)}</TableCell>
                  <TableCell>{transaction.currency}</TableCell>
                  <TableCell align="right">{formatMoney(transaction.amountEur)} EUR</TableCell>
                </TableRow>
              ))}
              <TableRow sx={{ bgcolor: 'action.hover' }}>
                <TableCell colSpan={3} />
                <TableCell sx={{ fontWeight: 700 }}>TOTAL</TableCell>
                <TableCell align="right" sx={{ fontWeight: 700 }}>
                  {formatMoney(row.amountEur)} EUR
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={row.transactions.length}
          page={page}
          onPageChange={(_event, value) => setPage(value)}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(Number(event.target.value));
            setPage(0);
          }}
          rowsPerPageOptions={[10, 25, 50, 100]}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Close</Button>
      </DialogActions>
    </Dialog>
  );
};
